import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { useForm } from 'react-hook-form';
import { login, clearAuthError, hydrateUser } from 'store/slices/authSlice';
import AuthPage from 'components/layout/AuthPage/AuthPage';
import { PrimaryButton, Link } from 'components/buttons/';
import { EmailField, PasswordField } from 'components/forms';

function Login() {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { user, loading, error } = useSelector((state) => state.auth);
  const { register, handleSubmit, formState: { errors, isDirty } } = useForm({ mode: "onChange" });

  useEffect(() => {
    if (user) navigate('/');
    return () => { dispatch(clearAuthError()); };
  }, [user, navigate, dispatch]);

  const onSubmit = async (data) => {
    const result = await dispatch(login(data));
    if (login.fulfilled.match(result)) {
      await dispatch(hydrateUser());
    }
  };

  const passwordLabelRightElement = (
    <div className="text-sm">
      <Link to="/forgot">Forgot password?</Link>
    </div>
  );

  return (
    <AuthPage title="Sign in to your account" error={error}>
      <form onSubmit={handleSubmit(onSubmit)} className="space-y-6">
        <EmailField register={register} errors={errors} />
        <PasswordField
          register={register}
          errors={errors}
          labelRightElement={passwordLabelRightElement}
        />
        <div>
          <PrimaryButton
            type="submit"
            disabled={loading || !isDirty}
            className="flex w-full justify-center"
          >
            {loading ? 'Logging in...' : 'Sign in'}
          </PrimaryButton>
        </div>
      </form>

      <p className="mt-10 text-center text-sm/6 text-gray-400">
        Not a member?{' '}
        <Link to="/register">Register</Link>
      </p>
    </AuthPage>
  )
}

export default Login;
